import { callExternalApi, CallResult } from '../../callExternalApi';
import { BlockListEntry, InternalUser } from '../../../types';

const INTERNAL_USERS_URL = 'api/admin/internal_users';
const BULK_SET_URL = 'api/admin/block_list_entries/bulk_set';

export const fetchInternalUsers = async (): Promise<CallResult<InternalUser[]>> =>
  await callExternalApi<InternalUser[]>({ url: INTERNAL_USERS_URL, method: 'GET' });

export const bulkSetBlockList = async (
  listType: string,
  portalUserIds: number[]
): Promise<CallResult<BlockListEntry[]>> =>
  await callExternalApi<BlockListEntry[]>({
    url: BULK_SET_URL,
    method: 'PUT',
    data: { list_type: listType, portal_user_ids: portalUserIds }
  });
